<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <v-alert :value="true" dense outlined type="error" v-if="error">
          {{ error }}
        </v-alert>
        <v-alert :value="true" dense outlined type="success" v-if="message">
          {{ message }}
        </v-alert>
        <v-form>
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 text-left><h4>Lisää tuote</h4></v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Tuotteen nimi"
                  prepend-icon="mdi-home-group"
                  :rules="[rules.required]"
                  v-model="addProductValues.productName"
                  autocomplete="off"
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Tuotteen hinta"
                  prepend-icon="mdi-home-group"
                  :rules="[rules.required]"
                  v-model="addProductValues.productPrice"
                  autocomplete="off"
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  prepend-icon="mdi-traffic-light"
                  v-model="addProductValues.productState"
                  :items="productState"
                  item-text="name"
                  item-value="value"
                  label="Tuotteen tila"
                  placeholder="Valitse"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn
                  class="mx-0 font-weight-light"
                  color="general"
                  @click.prevent="addNewProduct"
                >
                  Lisää tuote
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ProductService from '@/services/RentalClothesProductService.js';
export default {
  data() {
    return {
      productState: [
        { name: 'Käytössä', value: 'Käytössä' },
        { name: 'Poistettu käytöstä', value: 'Poistettu käytöstä' },
      ],
      addProductValues: {},
      message: null,
      error: null,
      rules: {
        required: (value) => !!value || 'Pakollinen kenttä',
      },
    };
  },
  methods: {
    async addNewProduct() {
      this.addProductValues.productPrice = this.addProductValues.productPrice.replace(
        ',',
        '.'
      );
      try {
        const response = await ProductService.addNewRentalClothesProduct(
          this.addProductValues
        );

        this.message = response.data.message;
        this.error = response.error;
        setTimeout(() => {
          this.error = null;
          this.message = null;
        }, 3000);
      } catch (error) {
        this.error = error.response.data.error;
        setTimeout(() => {
          this.error = null;
        }, 3000);
      }
    },
  },
};
</script>
